import { configureStore } from "@reduxjs/toolkit";
import { LoginAPI } from "../Services/LoginAPI";
import { CategoryAPI } from "../Services/CategoryAPI";
import { BrandsAPI } from "../Services/BrandsAPI";
import {myAccountAPI} from "../Services/myAccountAPI";
import { ProductAPI } from "../Services/ProductAPI";
import { SettingsAPI } from "../Services/SettingsAPI";
import {ContactAPI} from "../Services/ContactAPI"
import {OrdersAPI} from "../Services/OrdersAPI"
import {CustomerAPI} from "../Services/CustomerAPI"
import {PaymentModeAPI} from "../Services/PaymentmodeAPI"
import {StockAPI} from "../Services/StockManagemntAPI"
import {HomeAPI} from "../Services/HomeAPI"
import {AboutAPI} from "../Services/AboutAPI"
import { DasboardAPI } from "../Services/DasboardAPI";
import { CouponsAPI } from "../Services/CouponsAPI";
import { PrivacyPloicyAPI } from "../Services/PrivacyPolicy";

export const store = configureStore({
    reducer: {
        [LoginAPI.reducerPath]: LoginAPI.reducer,
        [CategoryAPI.reducerPath]: CategoryAPI.reducer,
        [BrandsAPI.reducerPath]: BrandsAPI.reducer,
        [myAccountAPI.reducerPath]: CategoryAPI.reducer,
        [ProductAPI.reducerPath]: ProductAPI.reducer,
        [SettingsAPI.reducerPath]: SettingsAPI.reducer,
        [ContactAPI.reducerPath]: ContactAPI.reducer,
        [OrdersAPI.reducerPath]: OrdersAPI.reducer,
        [CustomerAPI.reducerPath]: CustomerAPI.reducer,
        [PaymentModeAPI.reducerPath]: PaymentModeAPI.reducer,
        [StockAPI.reducerPath]: StockAPI.reducer,
        [HomeAPI.reducerPath]: HomeAPI.reducer,
        [AboutAPI.reducerPath]: AboutAPI.reducer,
        [DasboardAPI.reducerPath]: DasboardAPI.reducer,
        [CouponsAPI.reducerPath]: CouponsAPI.reducer,
        [PrivacyPloicyAPI.reducerPath]: PrivacyPloicyAPI.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(
            LoginAPI.middleware,
            CategoryAPI.middleware,
            BrandsAPI.middleware,
            myAccountAPI.middleware,
            ProductAPI.middleware,
            SettingsAPI.middleware,
            ContactAPI.middleware,
            OrdersAPI.middleware,
            CustomerAPI.middleware,
            PaymentModeAPI.middleware,
            StockAPI.middleware,
            HomeAPI.middleware,
            AboutAPI.middleware,
            DasboardAPI.middleware,
            CouponsAPI.middleware,
            PrivacyPloicyAPI.middleware,
        ),
});
